import { useState } from "react";
import { uploadImage, fileUrl } from "@/lib/api";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const Field = ({ field, value, onChange }) => {
  const [uploading, setUploading] = useState(false);
  const base = "w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-gold text-sm";

  if (field.type === "textarea")
    return <textarea rows={field.rows || 4} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={field.label} className={`${base} resize-none`} data-testid={`field-${field.name}`} />;

  if (field.type === "number")
    return <input type="number" value={value ?? ""} onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))} placeholder={field.label} className={base} data-testid={`field-${field.name}`} />;

  if (field.type === "select")
    return (
      <select value={value || ""} onChange={(e) => onChange(e.target.value)} className={base} data-testid={`field-${field.name}`}>
        <option value="">Pilih {field.label}</option>
        {field.options.map((o) => <option key={o} value={o} className="bg-[#0F1117]">{o}</option>)}
      </select>
    );

  if (field.type === "checkbox")
    return (
      <label className="flex items-center gap-2 text-white/80 text-sm cursor-pointer">
        <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} className="w-4 h-4 accent-[#D4AF37]" data-testid={`field-${field.name}`} /> {field.label}
      </label>
    );

  if (field.type === "image") {
    const handle = async (e) => {
      const file = e.target.files?.[0];
      if (!file) return;
      setUploading(true);
      try { const url = await uploadImage(file); onChange(url); toast.success("Gambar terunggah"); }
      catch { toast.error("Gagal mengunggah gambar"); }
      finally { setUploading(false); }
    };
    return (
      <div className="space-y-2">
        {value && <img src={fileUrl(value)} alt="preview" className="w-full h-40 object-cover rounded-xl gold-border" />}
        <label className="flex items-center justify-center gap-2 bg-white/5 border border-dashed border-white/20 rounded-xl px-4 py-3 text-white/70 text-sm cursor-pointer hover:border-gold">
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} {uploading ? "Mengunggah…" : "Unggah Gambar dari Komputer"}
          <input type="file" accept="image/*" className="hidden" onChange={handle} data-testid={`field-${field.name}`} />
        </label>
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="atau tempel URL gambar" className={base} />
      </div>
    );
  }

  return <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={field.label} className={base} data-testid={`field-${field.name}`} />;
};
